/**
 *  @class
 *  @function CartNotes
 */
if (!customElements.get('cart-notes')) {
  class CartNotes extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.toggle = this.querySelector('#order-note-toggle');
      this.notes = this.querySelector('#mini-cart__notes');
      this.content = this.querySelector('#mini-cart-note');
      this.drawer = this.closest('#Cart-Drawer');
      if (!this.toggle || !this.notes || !this.content || !this.drawer) return;

      // Mengen-, Rabatt- und Artikel-Updates ersetzen nur den Drawer-Inhalt.
      // Der fluechtige Entwurf bleibt deshalb am unveraenderten Drawer selbst.
      this.state = this.drawer.ivCartNoteState || (this.drawer.ivCartNoteState = {
        value: this.notes.value,
        hasDraft: false,
        open: false,
        revision: 0,
        saveSequence: 0,
        activeSave: null,
        queuedSave: null,
        error: false
      });
      if (this.state.hasDraft) this.notes.value = this.state.value;
      else this.state.value = this.notes.value;
      this.setOpen(this.state.open);
      if (this.state.error) this.meldung(true);

      if (this.events) this.events.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.notes.addEventListener('input', () => this.captureDraft(), options);
      this.toggle.addEventListener('click', (event) => {
        event.preventDefault();
        this.captureDraft();
        this.setOpen(!this.state.open);
      }, options);
      const saveButton = this.content.querySelector('.button');
      if (saveButton) saveButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.captureDraft();
        this.setOpen(false);
        this.saveNotes();
      }, options);
    }
    disconnectedCallback() {
      if (this.events) this.events.abort();
      // Einen bereits angeforderten Save nicht durch innerHTML abbrechen.
    }
    captureDraft() {
      if (this.notes.value !== this.state.value) {
        this.state.value = this.notes.value;
        this.state.revision += 1;
        this.state.hasDraft = true;
      }
    }
    setOpen(open) {
      if (!open && this.content.contains(document.activeElement)) {
        this.toggle.focus({ preventScroll: true });
      }
      this.state.open = open;
      this.content.classList.toggle('active', open);
      this.content.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
    }
    /*
     * iVoodoo (16.09.2026): Bis hierher lief das Speichern ohne jede Rueckmeldung -
     * Statuspruefung, Fehlerbehandlung und Zeitgrenze fehlten. Der Erfolgsfall ist
     * unveraendert; im Fehlerfall erscheint die Meldung der Schublade statt nichts.
     * Zeitgrenze 12 s wie in assets/ivoodoo-async-ui.js.
     */
    meldung(anzeigen) {
      const box = this.drawer.querySelector('[data-cart-drawer-error]');
      if (!box) return;
      if (!anzeigen) {
        box.setAttribute('hidden', 'hidden');
        return;
      }
      const ziel = box.querySelector('[data-cart-drawer-error-text]') || box;
      ziel.textContent = (window.theme && theme.strings && theme.strings.cartError) || '';
      box.removeAttribute('hidden');
    }
    saveNotes() {
      const state = this.state;
      const pending = state.queuedSave || state.activeSave;
      if (pending && pending.value === state.value && pending.revision === state.revision) return;
      state.queuedSave = {
        id: ++state.saveSequence,
        revision: state.revision,
        value: state.value
      };
      this.flushSave();
    }
    flushSave() {
      const state = this.state;
      if (state.activeSave || !state.queuedSave) return;
      const save = state.queuedSave;
      state.queuedSave = null;
      state.activeSave = save;
      // Explizite Saves laufen nacheinander; eine langsamere alte Anfrage kann
      // so keinen neueren Save ueberholen. Antworten schreiben nie den Entwurf.
      const current = () => save.id === state.saveSequence && save.revision === state.revision;
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), 12000);
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': save.value
        }),
        signal: controller.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Status ${response.status}`);
          }
          if (current()) {
            state.error = false;
            this.meldung(false);
          }
        })
        .catch(() => {
          if (current()) {
            state.error = true;
            this.meldung(true);
          }
        })
        .finally(() => {
          window.clearTimeout(timer);
          state.activeSave = null;
          this.flushSave();
        });
    }
  }
  customElements.define('cart-notes', CartNotes);
}
